module.exports = __webpack_public_path__ + "static/what-to-do-when-im-gone-fae0100f2ce66a17b2628e6d3dc61732.jpg";